import { API_URL } from '@funnels/constants';
import { Industry } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { axios } from './axios';

export function searchIndustries() {
  return axios
    .get<Industry[]>(`${API_URL}/v1/lists/industries`)
    .then((res) => res.data)
    .catch((err) => {
      datadogUtil.addError(err);
      return [];
    });
}
